import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { SignableStage, Signature } from '../../models/signature';

interface SignatureRequestPayload {
  documentType: 'docket' | 'booking' | 'saleDocket';
  documentId: number;
  code: string;
}

interface CreateSignaturePayload {
  signable_type: 'docket' | 'booking' | 'saleDocket';
  signable_id: number;
  image_encoded: string;
  print_name: string;
  delivery_id?: number | null;
  stage: SignableStage;
}

export const LS_DEVICE_CODE_NAME = 'signatureDeviceCode';

@Injectable()
export class SignatureService {
  constructor(private http: ApiClient) {}

  requestSignature(payload: SignatureRequestPayload) {
    return this.http.post<void>(`signature/request`, payload, {
      observe: 'response'
    });
  }

  saveSignature(payload: CreateSignaturePayload) {
    return this.http.post<Signature>(`signature`, payload);
  }

  getForSignable(signableType, signableId) {
    if (signableType === 'saleDocket') {
      signableType = 'sale-dockets';
    }
    return this.http.get<Signature[]>(
      `${signableType}/${signableId}/signatures`
    );
  }

  delete(id: number) {
    return this.http.delete(`signature/${id}`);
  }
}
